import { Droppable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { tokens } from '@treams/treams-ui';

import TalentReviewPerson from './TalentReviewPerson';

const Pool = styled(Flex)`
	position: relative;
	flex-wrap: nowrap;
	overflow-x: auto;
	overflow-y: hidden;
	border: 1px solid ${(props) => props.theme.colors.lightBlueLight};
	border-radius: 6px;
	padding: 10px;
`;

const Empty = styled(Flex)<{ visible?: boolean }>`
	color: ${tokens.text.secondary};
	font-size: 16px;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	transition: 0.4s ease-out opacity;

	opacity: ${(props) => (props.visible ? 1 : 0)};
`;

export default function TalentReviewTeam(props: {
	temporaryPlacements: graphql.TalentReviewPlacement[];
	users: graphql.User[];
	readonly?: boolean;
}) {
	const { t } = useTranslation();

	const selected = new Set(props.temporaryPlacements.map(({ user }) => user.id));
	const unselected = props.users.filter((user) => !selected.has(user.id));

	return (
		<Droppable droppableId="team" type="USER" direction="horizontal" isDropDisabled>
			{(provided) => (
				<Pool mt={3} mb={3} ref={provided.innerRef} {...provided.droppableProps}>
					<Empty visible={unselected.length === 0}>
						{t('talentReviews.edit.members.completed')}
					</Empty>
					{unselected.map((user, index) => (
						<TalentReviewPerson
							key={user.id}
							user={user as graphql.User}
							index={index}
							readonly={props.readonly}
						/>
					))}
					{provided.placeholder}
				</Pool>
			)}
		</Droppable>
	);
}
